import { createSharedComposable } from '@vueuse/core'
import { ref } from 'vue'

export const useSearchInputActive = () => {
  const isShow = ref<boolean>(false)

  return isShow
}

export const useSharedSearchInputActive = createSharedComposable(useSearchInputActive)
